import styled from 'styled-components';
import { Modal, Skeleton, Space } from 'antd';
import { useEffect, useRef } from 'react';
import { Form } from '@module/form';
import { CreateAssignmentForm } from './create-assignment-form.component';
import { PrimaryButton, SecondaryButton } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "create-assignment-modalcomponent__StyledModal",
  componentId: "sc-g6lmuy-0"
})(["width:60% !important;.ant-modal-content{padding:16px 20px;border-radius:12px;overflow:hidden;display:flex;flex-direction:column;height:95vh;}.ant-modal-header{border-bottom:none;flex-shrink:0;padding:0 0 12px;margin-bottom:0;}.ant-modal-body{overflow-y:hidden;flex:1;padding:0 4px;}.ant-modal-footer{flex-shrink:0;padding:12px 0 0;margin-top:0;}"]);
var StyledFormTitle = styled.span.withConfig({
  displayName: "create-assignment-modalcomponent__StyledFormTitle",
  componentId: "sc-g6lmuy-1"
})(["font-weight:700;font-size:20px;line-height:28px;"]);
export var CreateAssignmentModal = function CreateAssignmentModal(props) {
  var form = props.form,
      isModalVisible = props.isModalVisible,
      onCancelModal = props.onCancelModal,
      onCreateAssignment = props.onCreateAssignment,
      assignmentConfigsResponse = props.assignmentConfigsResponse,
      label = props.label,
      isLoadingCreateAssignment = props.isLoadingCreateAssignment,
      isDisableCreateAssignment = props.isDisableCreateAssignment,
      onFormValuesChange = props.onFormValuesChange,
      formErrorLabel = props.formErrorLabel,
      assignmentType = props.assignmentType,
      isAllowToEditSubmission = props.isAllowToEditSubmission,
      isUnlimitedEditSubmission = props.isUnlimitedEditSubmission,
      onToggleAllowToEditSubmission = props.onToggleAllowToEditSubmission,
      onToggleSelectUnlimitedEditSubmission = props.onToggleSelectUnlimitedEditSubmission,
      securityOptions = props.securityOptions,
      isLoadingGetSecurityOptions = props.isLoadingGetSecurityOptions,
      editorLabels = props.editorLabels,
      defaultAssignmentTitle = props.defaultAssignmentTitle;
  var prevDefaultTitleRef = useRef(undefined);
  useEffect(function () {
    if (!isModalVisible) {
      prevDefaultTitleRef.current = undefined;
      return;
    }

    var title = Form.getDefaultAssignmentTitle(defaultAssignmentTitle);

    if (!title) {
      return;
    }

    if (prevDefaultTitleRef.current !== defaultAssignmentTitle) {
      form.setFieldValue('title', title);
      onFormValuesChange();
      prevDefaultTitleRef.current = defaultAssignmentTitle;
    }
  }, [defaultAssignmentTitle, form, isModalVisible, onFormValuesChange]);

  var renderAssignmentFormContent = function renderAssignmentFormContent() {
    if (!assignmentConfigsResponse) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 8
        }
      });
    }

    return /*#__PURE__*/_jsx(CreateAssignmentForm, {
      form: form,
      assignmentConfigsResponse: assignmentConfigsResponse,
      onFormValuesChange: onFormValuesChange,
      label: label,
      errorLabel: formErrorLabel,
      assignmentType: assignmentType,
      isAllowToEditSubmission: isAllowToEditSubmission,
      isUnlimitedEditSubmission: isUnlimitedEditSubmission,
      onToggleAllowToEditSubmission: onToggleAllowToEditSubmission,
      onToggleSelectUnlimitedEditSubmission: onToggleSelectUnlimitedEditSubmission,
      securityOptions: securityOptions,
      isLoadingGetSecurityOptions: isLoadingGetSecurityOptions,
      editorLabels: editorLabels,
      isModalVisible: isModalVisible
    });
  };

  return /*#__PURE__*/_jsx(StyledModal, {
    centered: true,
    open: isModalVisible,
    onCancel: onCancelModal,
    destroyOnClose: true,
    title: /*#__PURE__*/_jsx(StyledFormTitle, {
      children: label.createAssignment
    }),
    footer: /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "small",
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        disabled: isLoadingCreateAssignment,
        size: "small",
        onClick: onCancelModal,
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        loading: isLoadingCreateAssignment,
        onClick: onCreateAssignment,
        disabled: isDisableCreateAssignment,
        children: label.assignQuiz
      })]
    }),
    children: renderAssignmentFormContent()
  });
};